<template>
  <v-dialog :value="value"
            fullscreen
            @keydown.esc="toClose">
    <div class="modal-container flex flex-column"
         :style="`background: ${$vuetify.theme.dark ? Colors.darkThemeDark3 : Colors.blueNight }`">
      <div class="flex justify-space-between container--height">
        <v-btn icon
               @click="toBack">
          <v-icon color="white">mdi-arrow-left</v-icon>
        </v-btn>
        <v-btn icon
               @click="toClose">
          <v-icon color="white">mdi-close</v-icon>
        </v-btn>
      </div>
      <div class="flex flex-column align-center justify-center align-items-center -mt-12">
        <img loading="lazy"
             :src="imageModal"
             alt="credit card"
             class="mb-8">
        <div>
          <v-slide-x-transition hide-on-leave>
            <stage-limit-balance v-show="isInit"
                                 @billing-stage-close="toClose"
                                 @billing-stage-credit="toCredit"/>
          </v-slide-x-transition>
          <v-slide-x-transition hide-on-leave>
            <stage-credit-card v-show="isCredit"
                               @billing-stage-close="toClose"
                               @billing-stage-init="toInit"
                               @billing-stage-other="toOther"/>
          </v-slide-x-transition>
          <v-slide-x-transition hide-on-leave>
            <stage-other-methods v-show="isOther"
                                 @billing-stage-close="toClose"
                                 @billing-stage-credit="toCredit" />
          </v-slide-x-transition>
        </div>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import { EventBus } from '@/eventBus'
import Colors from '@/utils/Colors'
import { StatusBalanceDialog } from './enums/statusBalanceDialog'
import StageLimitBalance from './components/stageLimitBalance.vue'
import StageCreditCard from './components/stageCreditCard.vue'
import stageOtherMethods from './components/stageOtherMethods.vue'

export default {
  name: 'AddBalance',
  components: {
    StageLimitBalance,
    StageCreditCard,
    stageOtherMethods
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  async mounted () {
    // FIX: Este evento deberia estar metido en un context ejemplo: billing:finish-upgrade
    EventBus.$on('billing:add-balance-close', () => {
      this.toClose()
    })
  },
  data () {
    return {
      status: StatusBalanceDialog.INIT,
      Colors
    }
  },
  computed: {
    imageModal () {
      return `${process.env.VUE_APP_STORAGE_URL}/files/bluebird/billing/credit-card.svg`
    },
    isInit () {
      return this.status === StatusBalanceDialog.INIT
    },
    isCredit () {
      return this.status === StatusBalanceDialog.CREDIT
    },
    isOther () {
      return this.status === StatusBalanceDialog.OTHER
    }
  },
  methods: {
    toInit () {
      this.status = StatusBalanceDialog.INIT
    },
    toCredit () {
      EventBus.$emit('billing:update-credit-card', true)
      this.status = StatusBalanceDialog.CREDIT
    },
    toOther () {
      this.status = StatusBalanceDialog.OTHER
    },
    toClose () {
      this.$emit('input', false)
      this.toInit()
    },
    toBack () {
      if (this.isInit) this.toClose()
      if (this.isCredit) this.toInit()
      if (this.isOther) this.toCredit()
    }
  }
}
</script>

<style scoped lang="scss">
.modal-container {
  padding: 2rem 4rem;
  color: white;
  height: 100%;
  .container--height {
    max-height: 5vh;
  }
}
</style>
